import { useLocation, Link } from "react-router-dom";
import { Home } from "lucide-react";
import sitemapRoutes from "@/sitemap-routes";

// Build labelMap and validRoutes dynamically from the central config
const labelMap: Record<string, string> = {};
sitemapRoutes.forEach((r) => {
  if (r.label) {
    const slug = r.path.split("/").pop()!;
    labelMap[slug] = r.label;
  }
});

const validRoutes = new Set(sitemapRoutes.map((r) => r.path));

const Breadcrumbs = () => {
  const { pathname } = useLocation();

  if (pathname === "/") return null;

  const segments = pathname.split("/").filter(Boolean);

  return (
    <nav aria-label="Kruimelpad" className="container pt-3 pb-1 text-xs text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-foreground transition-colors">
            <Home className="h-3 w-3" aria-hidden="true" />
            <span>Home</span>
          </Link>
        </li>
        {segments.map((segment, index) => {
          const path = "/" + segments.slice(0, index + 1).join("/");
          const isLast = index === segments.length - 1;
          const label = labelMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
          const hasRoute = validRoutes.has(path);
          return (
            <li key={path} className="inline-flex items-center gap-1.5">
              <span aria-hidden="true">›</span>
              {isLast || !hasRoute ? (
                <span aria-current={isLast ? "page" : undefined} className="text-foreground/80">
                  {label}
                </span>
              ) : (
                <Link to={path} className="hover:text-foreground transition-colors">
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
